import styled from 'styled-components';

const TableCellWidth = styled.div`
  width: ${({width}) => width};
  word-wrap: break-word;
  word-break: break-word;
`;

export default TableCellWidth;
